/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_Prep_TitleInputs */



/**
* | output |
* | --- |
* | "Preparation" |
*
* @param {Onboarding_Value_Prep_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_prep_title = /** @type {((inputs?: Onboarding_Value_Prep_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_Prep_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voorbereiding")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparation")
	return /** @type {LocalizedString} */ ("Preparation")
});